import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45635b74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transaction-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center p-12 min-h-[400px]"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-4 text-neutral-500 font-medium" }, "Memuat detail transaksi...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-1 border-b border-neutral-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file text-blue-500 text-xl" }),
    /*#__PURE__*/_createElementVNode("h2", { class: "text-xl md:text-2xl font-bold text-neutral-800" }, "Detail Transaksi")
  ])
], -1))
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 py-6 border-b border-neutral-100" }
const _hoisted_6 = { class: "flex flex-col gap-3.5 border-r border-dashed border-neutral-200 pr-6 last:border-0" }
const _hoisted_7 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_8 = { class: "text-lg font-bold text-neutral-800" }
const _hoisted_9 = { class: "text-sm font-semibold text-neutral-700" }
const _hoisted_10 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Nopol:", -1))
const _hoisted_12 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_13 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "No. Lambung:", -1))
const _hoisted_15 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_16 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Nama Kru:", -1))
const _hoisted_18 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_19 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Jenis Transaksi:", -1))
const _hoisted_21 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_22 = { class: "flex flex-col gap-3.5" }
const _hoisted_23 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Kupon BBM / PP:", -1))
const _hoisted_25 = { class: "font-bold text-neutral-800 col-span-2 text-sm truncate cursor-help" }
const _hoisted_26 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Pembelian:", -1))
const _hoisted_28 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_29 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Nominal (Rp):", -1))
const _hoisted_31 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_32 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Nama Operator Pom:", -1))
const _hoisted_34 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_35 = { class: "md:grid grid-cols-3 items-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 shrink-0" }, "Pom Mitra:", -1))
const _hoisted_37 = { class: "font-bold text-neutral-800 col-span-2 text-sm" }
const _hoisted_38 = { class: "py-6 border-b border-neutral-100" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-neutral-800 mb-4" }, "Bukti Transaksi", -1))
const _hoisted_40 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_41 = { class: "flex flex-col gap-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 font-medium" }, "Foto Meteran:", -1))
const _hoisted_43 = { class: "w-full h-48 rounded-lg overflow-hidden flex items-center justify-center bg-neutral-100 border border-neutral-200 group relative" }
const _hoisted_44 = {
  key: 1,
  class: "text-neutral-600 flex flex-col items-center gap-2 text-xs"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image text-3xl text-neutral-300" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tidak ada foto meteran", -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = { class: "flex flex-col gap-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 font-medium" }, "Foto Nopol:", -1))
const _hoisted_50 = { class: "w-full h-48 rounded-lg overflow-hidden flex items-center justify-center bg-neutral-100 border border-neutral-200 group relative" }
const _hoisted_51 = {
  key: 1,
  class: "text-neutral-600 flex flex-col items-center gap-2 text-xs"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image text-3xl text-neutral-300" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tidak ada foto nopol", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = { class: "flex flex-col gap-2" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-500 font-medium" }, "Foto Nota:", -1))
const _hoisted_57 = { class: "w-full h-48 rounded-lg overflow-hidden flex items-center justify-center bg-neutral-100 border border-neutral-200 group relative" }
const _hoisted_58 = {
  key: 1,
  class: "text-neutral-600 flex flex-col items-center gap-2 text-xs"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image text-3xl text-neutral-300" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tidak ada foto nota", -1))
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = { class: "py-6 border-b border-neutral-100" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-neutral-800 mb-4" }, "Keterangan", -1))
const _hoisted_64 = { class: "flex items-start gap-3" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-600 w-20 shrink-0" }, "Alasan:", -1))
const _hoisted_66 = { class: "flex-1" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 1,
  class: "text-sm font-bold text-neutral-800"
}
const _hoisted_69 = {
  key: 1,
  class: "text-sm font-bold text-neutral-800"
}
const _hoisted_70 = { class: "py-6" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 0,
  class: "mt-4 flex flex-col gap-2 min-w-0"
}
const _hoisted_73 = { class: "text-sm text-neutral-500" }
const _hoisted_74 = { class: "font-bold text-neutral-700" }
const _hoisted_75 = { class: "flex border-b border-neutral-200 mt-2" }
const _hoisted_76 = { class: "border border-neutral-200 rounded-lg overflow-hidden w-full relative min-h-[200px] mt-2" }
const _hoisted_77 = {
  key: 0,
  class: "absolute inset-0 bg-white/80 flex items-center justify-center z-10"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center p-8 text-neutral-600" }, "Tidak ada riwayat pengisian.", -1))
const _hoisted_79 = {
  key: 0,
  class: "text-blue-500 text-xs ml-1 font-medium"
}
const _hoisted_80 = { class: "font-semibold text-neutral-800" }
const _hoisted_81 = {
  key: 0,
  class: "flex justify-center mt-2"
}
const _hoisted_82 = { class: "flex items-center justify-end mt-4" }
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Kembali")

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import moment from 'moment'
import Card from 'primevue/card'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import Paginator from '@/views/components/paginator/Paginator.vue'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import environment from '@/configs/environtment'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useFuelTransactionDetail } from '@/composables/pages/externals/fuel-monitoring/useFuelTransactionDetail'
import { useApprovalStatus } from '@/composables/useApprovalStatus'
import apiUseCase from '@/usecase/apiUseCase'
import Dialog from 'primevue/dialog'
import ImageViewer from '@/views/shared-components/ImageViewer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FuelingTransactionDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const {
  fetchApprovalStatuses,
  getDynamicStatusColor,
  getDynamicStatusBg,
  getDynamicStatusText
} = useApprovalStatus()

const {
  isLoadingDetail,
  isLoadingHistory,
  transactionDetail,
  historyData,
  activeHistoryTab,
  historyPaginate,
  onChangeHistoryTab,
  onChangeHistoryPage,
  fetchHistory,
} = useFuelTransactionDetail()

// Collapsible history: default hidden
const isHistoryVisible = ref(false)

const toggleHistory = () => {
  isHistoryVisible.value = !isHistoryVisible.value
  // Fetch history data on first show
  if (isHistoryVisible.value && historyData.value.length === 0 && transactionDetail.value) {
    fetchHistory()
  }
}

const fetchDetailData = async (id: string) => {
  isLoadingDetail.value = true
  try {
    const response = await apiUseCase.get(`/transaction/v2/FuelingTransactions/${id}`)
    if (!response.error) {
      transactionDetail.value = response.result

      // Update breadcrumbs once we have the code
      store.dispatch('ui/setBreadcrumbs', [
        { title: 'Approve Setoran', routeName: 'approve-deposits' },
        { title: 'Lihat Detail', routeName: 'approve-deposits-fueling-detail' }
      ])
    }
  } catch (err) {
    console.error(err)
  } finally {
    isLoadingDetail.value = false
  }
}

const formatRupiah = (val?: number) => {
  if (val === undefined || val === null) return 'Rp 0'
  return rupiahFormat(val)
}

const getTransactionTypeLabel = (type?: string) => {
  if (!type) return '-'
  switch (type) {
    case 'ScanHjCrew': return 'Scan Kru HJ'
    case 'ManualInput': return 'Input Manual'
    case 'ScanAplikasi': return 'Scan Aplikasi'
    default: return type
  }
}

const getFullImageUrl = (path?: string) => {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  const prefixPath = changeImagePathPrefix(path)
  return `${environment.getApiImageBaseUrl()}${prefixPath}`
}

const viewFullImage = (path?: string) => {
  if (path) {
    const fullUrl = getFullImageUrl(path)
    window.open(fullUrl, '_blank')
  }
}

const goBack = () => {
  router.go(-1)
}

onMounted(() => {
  // Set initial breadcrumb while loading
  store.dispatch('ui/setBreadcrumbs', [
    { title: 'Approve Setoran', routeName: 'approve-deposits' },
    { title: 'Lihat Detail', routeName: 'approve-deposits-fueling-detail' }
  ])

  fetchApprovalStatuses()

  if (route.params.id) {
    try {
      // Decrypt ID
      const decryptedData = encryptDecriptMethods.decrypt(route.params.id as string)
      const id = typeof decryptedData === 'string' ? decryptedData : (decryptedData.Id || decryptedData)

      // Initialize tab and fetch data
      activeHistoryTab.value = 'nopol'
      historyPaginate.value.pageNumber = 1

      fetchDetailData(id)
    } catch (e) {
      console.error('Error decrypting route param', e)
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ProgressSpinner), {
            style: {"width":"50px","height":"50px"},
            strokeWidth: "4"
          }),
          _hoisted_3
        ]))
      : (_unref(transactionDetail))
        ? (_openBlock(), _createBlock(_unref(Card), {
            key: 1,
            class: "card-no-shadow mb-4"
          }, {
            content: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(transactionDetail).Code), 1),
                    _createElementVNode("span", {
                      class: "text-xs font-bold px-3 py-1 rounded border transition-all duration-200",
                      style: _normalizeStyle({
                  color: _unref(getDynamicStatusColor)(_unref(transactionDetail).ApprovalStatus),
                  borderColor: _unref(getDynamicStatusColor)(_unref(transactionDetail).ApprovalStatus),
                  backgroundColor: _unref(getDynamicStatusBg)(_unref(transactionDetail).ApprovalStatus)
                })
                    }, _toDisplayString(_unref(getDynamicStatusText)(_unref(transactionDetail).ApprovalStatus, _unref(transactionDetail).ApprovalStatusDisplayName)), 5)
                  ]),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(moment)(_unref(transactionDetail).CreatedAt).format('DD MMM YYYY - HH:mm:ss')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(transactionDetail).VehicleRegNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(transactionDetail).VehicleHullNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(transactionDetail).CrewName || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(getTransactionTypeLabel(_unref(transactionDetail).TransactionType)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_25, [
                      _createTextVNode(_toDisplayString(_unref(transactionDetail).TransactionPp?.TrayekName || _unref(transactionDetail).FuelTransactionVoucher?.Code || '-'), 1)
                    ])), [
                      [
                        _directive_tooltip,
                        _unref(transactionDetail).TransactionPp?.TrayekName || _unref(transactionDetail).FuelTransactionVoucher?.Code || '-',
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(transactionDetail).Liters || 0) + " L", 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, _toDisplayString(formatRupiah(_unref(transactionDetail).Price)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(transactionDetail).FuelStationPartnerOperatorName || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(transactionDetail).FuelStationPartnerName || '-'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      (_unref(transactionDetail).MeterImageUrl)
                        ? (_openBlock(), _createBlock(ImageViewer, {
                            key: 0,
                            url: getFullImageUrl(_unref(transactionDetail).MeterImageUrl),
                            width: "300px",
                            height: "300px"
                          }, null, 8, ["url"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_47))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("div", _hoisted_50, [
                      (_unref(transactionDetail).VehicleImageUrl)
                        ? (_openBlock(), _createBlock(ImageViewer, {
                            key: 0,
                            url: getFullImageUrl(_unref(transactionDetail).VehicleImageUrl),
                            width: "300px",
                            height: "300px"
                          }, null, 8, ["url"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_54))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("div", _hoisted_57, [
                      (_unref(transactionDetail).ReceiptImageUrl)
                        ? (_openBlock(), _createBlock(ImageViewer, {
                            key: 0,
                            url: getFullImageUrl(_unref(transactionDetail).ReceiptImageUrl),
                            width: "300px",
                            height: "300px"
                          }, null, 8, ["url"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, [
                    (_unref(transactionDetail).Notes)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (Array.isArray(_unref(transactionDetail).Notes))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transactionDetail).Notes, (note) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: note,
                                    class: "text-sm font-bold text-neutral-800 mb-1"
                                  }, _toDisplayString(note), 1))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_unref(transactionDetail).Notes), 1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_69, "-"))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("a", {
                  href: "#",
                  class: "text-blue-500 hover:text-blue-600 text-sm font-semibold flex items-center gap-1 transition-colors duration-150",
                  onClick: _withModifiers(toggleHistory, ["prevent"])
                }, [
                  _createTextVNode(_toDisplayString(isHistoryVisible.value ? 'Sembunyikan' : 'Tampilkan') + " Riwayat Pengisian BBM ", 1),
                  _createElementVNode("i", {
                    class: _normalizeClass(["pi text-xs", isHistoryVisible.value ? 'pi-chevron-up' : 'pi-angle-right'])
                  }, null, 2)
                ], 8, _hoisted_71),
                (isHistoryVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("p", _hoisted_73, [
                        _createTextVNode(" Berikut daftar riwayat transaksi pengisian BBM yang dilakukan oleh " + _toDisplayString(_unref(activeHistoryTab) === 'nopol' ? 'Nopol' : 'Kru') + ": ", 1),
                        _createElementVNode("span", _hoisted_74, _toDisplayString(_unref(activeHistoryTab) === 'nopol' ? (_unref(transactionDetail).VehicleRegNumber || '-') : (_unref(transactionDetail).CrewName || '-')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onChangeHistoryTab)('nopol'))),
                          class: _normalizeClass(["px-6 py-2.5 font-semibold text-sm transition-all duration-150 border-b-2 -mb-px", _unref(activeHistoryTab) === 'nopol' ? 'border-blue-500 text-blue-500' : 'border-transparent text-neutral-600 hover:text-neutral-600'])
                        }, " Nopol ", 2),
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onChangeHistoryTab)('kru'))),
                          class: _normalizeClass(["px-6 py-2.5 font-semibold text-sm transition-all duration-150 border-b-2 -mb-px", _unref(activeHistoryTab) === 'kru' ? 'border-blue-500 text-blue-500' : 'border-transparent text-neutral-600 hover:text-neutral-600'])
                        }, " Kru ", 2)
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        (_unref(isLoadingHistory))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                              _createVNode(_unref(ProgressSpinner), {
                                style: {"width":"40px","height":"40px"},
                                strokeWidth: "4"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(DataTable), {
                          value: _unref(historyData),
                          responsiveLayout: "scroll",
                          class: "excel-clone",
                          showHeader: true
                        }, {
                          empty: _withCtx(() => [
                            _hoisted_78
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(Column), {
                              field: "CreatedAt",
                              header: "TANGGAL"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(_unref(moment)(slotProps.data.CreatedAt).format('DD/MM/YYYY - HH:mm:ss')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Column), {
                              field: "Liters",
                              header: "PEMBELIAN BBM"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createElementVNode("span", null, _toDisplayString(slotProps.data.Liters || 0) + " Liter", 1),
                                (slotProps.data.FuelTransactionVoucher)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_79, " (Kupon BBM) "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Column), {
                              field: "FuelStationPartnerName",
                              header: "POM BENSIN"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.data.FuelStationPartnerName || '-'), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(Column), {
                              field: _unref(activeHistoryTab) === 'kru' ? 'VehicleRegNumber' : 'CrewName',
                              header: _unref(activeHistoryTab) === 'kru' ? 'NOPOL' : 'NAMA KRU'
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString((_unref(activeHistoryTab) === 'kru' ? slotProps.data.VehicleRegNumber : slotProps.data.CrewName) || '-'), 1)
                              ]),
                              _: 1
                            }, 8, ["field", "header"]),
                            _createVNode(_unref(Column), {
                              field: "Price",
                              header: "HARGA",
                              class: "text-right"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createElementVNode("span", _hoisted_80, _toDisplayString(formatRupiah(slotProps.data.Price)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      (_unref(historyPaginate).totalRecords > _unref(historyPaginate).pageSize)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            _createVNode(Paginator, {
                              first: ((_unref(historyPaginate).pageNumber || 1) - 1) * (_unref(historyPaginate).pageSize || 5),
                              rows: _unref(historyPaginate).pageSize,
                              totalRecords: _unref(historyPaginate).totalRecords,
                              onOnPage: _unref(onChangeHistoryPage)
                            }, null, 8, ["first", "rows", "totalRecords", "onOnPage"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_82, [
                _createVNode(_unref(Button), {
                  class: "btn-default bg-neutral-200 border-neutral-200 text-black hover:bg-neutral-300 w-32 justify-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goBack()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_83
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ]))
}
}

})